import type { SubmissionRow } from "../api/helloAppClient.ts";
import { formatDate } from "../utils/formatDate.ts";

interface FilesListProps {
  rows: SubmissionRow[];
}

export function FilesList({ rows }: FilesListProps) {
  if (rows.length === 0) {
    return (
      <div className="submissions-empty">
        <span className="submissions-empty__title">ไม่มีไฟล์</span>
        <span>อัปโหลดผ่าน LINE หรือฟอร์มด้านบนเพื่อเริ่มต้น</span>
      </div>
    );
  }
  return (
    <ul className="files-list">
      {rows.map((row, i) => (
        <li key={`${row.submittedAt}-${i}`} className="files-list__item">
          <FileIcon />
          <a
            href={row.fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="files-list__name"
          >
            {row.fileName}
          </a>
          <time className="files-list__time" dateTime={row.submittedAt}>
            {formatDate(row.submittedAt)}
          </time>
        </li>
      ))}
    </ul>
  );
}

function FileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  );
}
